import { create } from 'zustand'
import type { InfographicConcept } from '../types'

export type InfographicStyle =
  | 'more-technical'
  | 'simpler-language'
  | 'visual-focus'
  | 'warranty-emphasis'
  | 'step-by-step'
  | 'surprise-me'

export interface InfographicVersion {
  id: string
  infographic: InfographicConcept
  style?: InfographicStyle
  timestamp: Date
}

interface InfographicState {
  // Current versions for the active query
  versions: InfographicVersion[]
  currentVersionIndex: number
  isRegenerating: boolean

  // Actions
  addVersion: (infographic: InfographicConcept, style?: InfographicStyle) => void
  setCurrentVersion: (index: number) => void
  clearVersions: () => void
  setIsRegenerating: (isRegenerating: boolean) => void
  getCurrentVersion: () => InfographicVersion | null
}

const MAX_VERSIONS = 10

export const useInfographicStore = create<InfographicState>((set, get) => ({
  versions: [],
  currentVersionIndex: 0,
  isRegenerating: false,

  addVersion: (infographic, style) => {
    const newVersion: InfographicVersion = {
      id: `version-${Date.now()}`,
      infographic,
      style,
      timestamp: new Date()
    }

    set((state) => {
      const updatedVersions = [...state.versions, newVersion]

      // Keep only the last MAX_VERSIONS
      const versions = updatedVersions.slice(-MAX_VERSIONS)

      return {
        versions,
        currentVersionIndex: versions.length - 1
      }
    })
  },

  setCurrentVersion: (index) => {
    const { versions } = get()
    if (index >= 0 && index < versions.length) {
      set({ currentVersionIndex: index })
    }
  },

  clearVersions: () => {
    set({
      versions: [],
      currentVersionIndex: 0,
      isRegenerating: false
    })
  },

  setIsRegenerating: (isRegenerating) => {
    set({ isRegenerating })
  },

  getCurrentVersion: () => {
    const { versions, currentVersionIndex } = get()
    return versions[currentVersionIndex] || null
  }
}))
